import axios from "@/lib/axios";

const getCustomers = () => {
  return axios.get("/facility/flat_rates/customers");
}

export default getCustomers;